module.exports = __webpack_public_path__ + "img/hutaomu3.29a5e252.jpg";